import {Component, Input} from '@angular/core';

/**
 * Component for showing flippable co2 tipps
 */
@Component({
    selector: 'app-co2info',
    templateUrl: './co2info.component.html',
    standalone: false
})
export class Co2InfoComponent {
  /**
   * textkey for the teaser text on the front
   */
  @Input() teaser: string

  /**
   * textkey for the content on the back
   */
  @Input() text: string

  /**
   * placeholder to be used inside the texts
   */
  @Input() placeholder: any = {};

  /**
   * toggle for show/hide the content
   */
  show: boolean;

  constructor() { }
}
